// @flow
import { connect } from 'react-redux';
import Template from './component';
import { templates } from '~/core/utils/recipes';

const mapStateToProps = (state, { name, selectTemplate }) => {
    const template = templates[name];

    return {
        active: template.producer.active,
        consumerType: template.isNotification ? null : template.consumer.types[0],
        isNotification: template.isNotification === true,
        producerType: template.producer.type,
        selectTemplate
    };
};

// $FlowFixMe
export default connect(mapStateToProps)(Template);



// WEBPACK FOOTER //
// ./src/components/widgets/recipes/template/index.js